<template>
    <v-container fluid grid-list-xl class="pt-0">
        <v-layout align-center wrap>
            <v-flex pt-0>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>
                            <v-icon>fa fa-eye</v-icon>
                            Detalles del Colaborador
                        </v-toolbar-title>
                        <v-divider class="mx-2" inset vertical></v-divider>

                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-btn icon @click="printEmpleado">
                                <v-icon>fa-print</v-icon>
                            </v-btn>
                            <v-btn icon @click="cancelForm()">
                                <v-icon>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-container fluid grid-list-xl class="px-1 py-1">
                            <v-layout align-center wrap>
                                <v-flex xs12 sm2 pr-0 pl-4 style="max-width: 174px">
                                    <v-avatar size="150">
                                        <v-img
                                            :src="detailsItem.imagen ? detailsItem.imagen : require('@/images/avatar.png')"
                                        ></v-img>
                                    </v-avatar>
                                </v-flex>
                                <v-flex xs12 sm4 pa-0 pt-2>
                                    <h4 :class="getRecontratacionDatos(detailsItem).textColor">
                                        {{
                                            detailsItem.nombre +
                                                " " +
                                                detailsItem.apellido_paterno +
                                                " " +
                                                detailsItem.apellido_materno
                                        }}
                                    </h4>
                                    <div class="blue--text text-xs-center mb-2">Código: {{ detailsItem.codigo }}</div>
                                    <div :class="getRecontratacionDatos(detailsItem).textColor">
                                        {{ detailsItem.status_description }}
                                    </div>
                                    <div class="text-xs-center pt-3">
                                        <template v-if="detailsItem.recontratacion === 3 && isNotUserRRHH_Asistente()">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        flat
                                                        icon
                                                        :loading="loading"
                                                        color="primary"
                                                        @click="aprobarItem(detailsItem)"
                                                    >
                                                        <v-icon medium v-on="on">fa-thumbs-up</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Aprobar</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        flat
                                                        icon
                                                        :loading="loading"
                                                        color="red"
                                                        @click="rechazarItem(detailsItem)"
                                                    >
                                                        <v-icon medium v-on="on">fa-thumbs-down</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Rechazar</span>
                                            </v-tooltip>
                                        </template>
                                        <v-btn
                                            v-if="detailsItem.recontratacion === 1 || detailsItem.recontratacion === 2"
                                            small
                                            round
                                            outline
                                            color="orange"
                                            flat
                                            :loading="loading"
                                            @click="toogleStatus(detailsItem)"
                                        >
                                            {{ detailsItem.recontratacion === 1 ? "Terminar contrato" : "Recontratar" }}
                                        </v-btn>
                                        <v-btn
                                            flat
                                            small
                                            round
                                            outline
                                            color="orange"
                                            :disabled="loading"
                                            @click="openForm(detailsItem)"
                                        >
                                            Editar
                                        </v-btn>
                                    </div>
                                </v-flex>

                                <v-flex sm6>
                                    <v-container fluid grid-list-xl class="px-1 py-0">
                                        <v-layout align-center wrap>
                                            <v-divider inset vertical></v-divider>
                                            <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Campus:</v-flex>
                                                <v-flex sm5>{{ detailsItem.campus.nombre }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Departamento:</v-flex>
                                                <v-flex sm5>{{ detailsItem.departamento.nombre }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Sección:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.seccion ? detailsItem.seccion.nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Puesto:</v-flex>
                                                <v-flex sm5>{{ detailsItem.puesto.nombre }}</v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex sm12>
                                    <v-divider></v-divider>
                                    <v-container fluid grid-list-xl class="px-1 py-1">
                                        <v-layout align-center wrap>
                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Género:</v-flex>
                                                            <v-flex sm5>{{ detailsItem.sexo.nombre }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Estado civil:</v-flex
                                                            >
                                                            <v-flex sm5>{{ detailsItem.estado_civil.nombre }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Cedula:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.cedula ? detailsItem.cedula : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>CURP:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.curp ? detailsItem.curp : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>RFC:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.rfc ? detailsItem.rfc : "-"
                                                                }}</v-flex>

                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Hijos:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.hijos ? detailsItem.hijos : "-"
                                                                }}</v-flex>

                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Fecha nacimiento:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.fecha_nacido + "(" + getEdad() + " años)"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Fecha ingreso:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.fecha_ingreso
                                                                    ? detailsItem.fecha_ingreso
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Contactos:</v-flex
                                                            >
                                                            <v-flex sm5>
                                                                (tel. )
                                                                {{ detailsItem.telefono ? detailsItem.telefono : "-"
                                                                }}<br />
                                                                (cel. )
                                                                {{ detailsItem.celular ? detailsItem.celular : "-"
                                                                }}<br />
                                                                (correo. )
                                                                {{ detailsItem.email ? detailsItem.email : "-" }}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Escolaridad:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.escolaridad
                                                                    ? detailsItem.escolaridad.nombre
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Título:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.titulo ? detailsItem.titulo.nombre : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Dirección:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.direccion ? detailsItem.direccion : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex sm12>
                                    <v-divider></v-divider>
                                    <v-container fluid grid-list-xl class="px-1 pt-1 pb-3">
                                        <v-layout align-center wrap>
                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Tipo pago:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.tipo_pago === 1 ? "Fijo" : "Por horas"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Fondo horario:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.fondo_horario
                                                                    ? detailsItem.fondo_horario
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Salario por asesor:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.asesor === 1
                                                                    ? "MX " + detailsItem.plus
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Salario:</v-flex
                                                            >
                                                            <v-flex sm5>{{ "MX " + detailsItem.salario }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Salario bruto:</v-flex
                                                            >
                                                            <v-flex sm5>{{ "MX " + detailsItem.salario_bruto }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Tipo contrato:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                tipo_contrato[detailsItem.tipo_contratacion - 1]
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Impuesto nómina:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.impuesto_nomina
                                                                    ? "MX " + detailsItem.impuesto_nomina
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Cuota:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.cuota ? "MX " + detailsItem.cuota : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>ISR:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.isr ? "MX " + detailsItem.isr : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>IMSS:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.imss ? "MX " + detailsItem.imss : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm12 text-xs-center
                                                                >Documentos entregados:</v-flex
                                                            >
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Cedula:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.rcedula === 1 ? "si" : "no"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Domicilio:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rdomicilio === 1 ? "si" : "no"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Título:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.rtitulo === 1 ? "si" : "no"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Acta nacimiento:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.ractanacido === 1 ? "si" : "no"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>CURP:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.rcurp === 1 ? "si" : "no"
                                                            }}</v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <empleado-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </empleado-form>

        <baja-form v-if="showBajaForm" :form-title="title" :initial-item="editItem" @formCanceled="toogleStatus">
        </baja-form>

        <print-empleado-template
            v-show="false"
            :empleado-object="detailsItem"
            id="printEmpleado"
        ></print-empleado-template>
    </v-container>
</template>

<script>
const PrintEmpleadoTemplate = () => import("@/views/personal/empleado/Empleado/print-empleado-template")
const EmpleadoForm = () => import("@/components/personal/empleado/empleado-form/empleado-form")
const BajaForm = () => import("@/components/personal/nomencladores/baja-form/baja-form")
import { mapGetters } from "vuex"
export default {
    name: "EmpleadoDetails",
    components: { PrintEmpleadoTemplate, EmpleadoForm, BajaForm },
    props: {
        item: { type: Object, default: null }
    },
    data() {
        return {
            tipo_contrato: ["COLEGIO_IMSS", "COLEGIO_HONORARIOS", "OUTSOURCING_IMSS", "OUTSOURCING_HONORARIOS"],
            loading: false,

            title: "",
            showForm: false,
            showBajaForm: false,
            editItem: null
        }
    },
    methods: {
        cancelForm() {
            this.$emit("detailsCanceled")
        },

        getEdad() {
            let fnacido = this.detailsItem.fecha_nacido.split("/")[2]
            let today = new Date()
                .toISOString()
                .substr(0, 10)
                .split("-")[0]
            return today - fnacido
        },

        openForm(item) {
            this.title = "Modificar empleado"
            this.editItem = item
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },



        toogleStatus(item) {

           if(item){

             this.editItem = item
             if(item.recontratacion===1){
               this.title = "Motivo Baja"
               this.showBajaForm = !this.showBajaForm
             }else if(item.recontratacion===2){
               this.loading = true
               this.$store.dispatch("TOGGLE_STATUS_EMPLEADO", item).then(() => {
                 this.loading = false
               })
             }
           }else this.showBajaForm = !this.showBajaForm



        },

        aprobarItem(item) {
            this.loading = true
            this.$store.dispatch("APROBE_EMPLEADO", item).then(() => {
                this.loading = false
            })
        },

        rechazarItem(item) {
            this.loading = true
            this.$store.dispatch("REJECT_EMPLEADO", item).then(() => {
                this.loading = false
            })
        },

        getRecontratacionDatos(item) {
            switch (item.recontratacion) {
                case 1:
                    return { textColor: "headline mb-2 text-xs-center" }
                case 2:
                    return { textColor: "headline mb-2 text-xs-center red--text" }
                case 3:
                    return { textColor: "headline mb-2 text-xs-center orange--text" }
                case 4:
                    return { textColor: "headline mb-2 text-xs-center grey--text" }
                default:
                    return ""
            }
        },

        isNotUserRRHH_Asistente() {
            let roles = this.$store.getters.CURRENT_USER.roles.filter(rol => rol.name !== "rrhh_asistente")
            return roles.length > 0
        },

        printEmpleado() {
            this.$htmlToPaper("printEmpleado")
        }
    },

    computed: {
        ...mapGetters(["EMPLEADOS"]),

        detailsItem() {
            return this.EMPLEADOS.filter(el => el.id === this.item.id)[0]
        },

    },
    watch:{
          detailsItem(){
            if(this.detailsItem){
              this.$store.dispatch("LOAD_EMPLEADO_DETAILS",this.detailsItem)
            }
          }
      }
}
</script>

<style scoped></style>
